import React from "react";
import { CSVLink } from "react-csv";
import moment from "moment";

const DownloadCsv = ({ data, columns, filename }) => {
  const prepareCsvData = () => {
    const csvData = data.map((item) => {
      const formattedData = {};
      columns.forEach((column) => {
        if (column.type === "date") {
          const formattedDate = moment(item[column.key]).format("DD-MM-YYYY");
          formattedData[column.key] = formattedDate;
        } else {
          formattedData[column.key] = item[column.key];
        }
      });
      return formattedData;
    });
    return { csvData, formattedDate: moment().format("DD-MM-YYYY") };
  };

  const { csvData, formattedDate } = prepareCsvData();

  return (
    <CSVLink
      data={csvData}
      target="_blank"
      filename={`${filename}_${formattedDate}.csv`}
    >
      Download CSV
    </CSVLink>
  );
};

export default DownloadCsv;
